import RetailerSignupFooter from '@marketplace/components/signup/parts/retailer-signup-footer.vue'
import { ACCOUNT_UPDATE_MUTATION } from '@marketplace/graphql/account'
import {
    getUnlocalizedPathFromRoute,
    unlocalizeRouteName,
} from '@marketplace/helpers/router.js'
import { trackGQLErrors } from '@marketplace/helpers/segment/errorTracking'
import { pageView, trackClick } from '@marketplace/helpers/segment/index.js'
import { getLocaleFromPath } from '@marketplace/helpers/url.js'
import smoothscroll from 'smoothscroll-polyfill'

import { AVAILABLE_RETAILER_SIGNUP_STEPS } from '~/config/retailerSignup'

smoothscroll.polyfill()

export default {
    components: {
        RetailerSignupFooter,
    },

    props: {
        viewer: {
            type: Object,
            default: () => {},
        },
    },

    data() {
        return {
            buttonDisabled: false,
            userErrors: [],
            pageAnimateIn: false,
        }
    },

    beforeRouteEnter(to, from, next) {
        const localeLessPath = getUnlocalizedPathFromRoute(to)
        const stepName = unlocalizeRouteName(to.name)
        const locale = getLocaleFromPath(to.path)

        pageView({
            pageType: 'Retailer Registration',
            otherBatchedPayload: {
                step: stepName,
            },
            locale,
            localeLessPath,
            fullPath: to.fullPath,
            referrer: to.meta.referrer,
        })
        next((vm) => {
            vm.pageAnimateIn = false
        })
    },

    mounted() {
        this.$emit('signup-step', this.$page.currentRouteName)
        this.pageAnimateIn = true
    },

    computed: {
        serverErrors() {
            const serverErrorsList = {}
            if (this.userErrors?.length > 0) {
                this.userErrors.forEach((error) => {
                    error.field.forEach((err) => {
                        serverErrorsList[err] = error.message
                    })
                })
            }
            return serverErrorsList
        },
        stepNameForTracking() {
            return (
                AVAILABLE_RETAILER_SIGNUP_STEPS?.[this.$page.currentRouteName]
                    ?.trackingStepName || 'error'
            )
        },
    },

    methods: {
        unlocalizeRouteName,

        /**
         * Accepts a payload of viewer props that the updateMutation allows.
         * Handles the mutation
         * Handles loading state on button
         * After GQL success redirects to provided vue route
         *
         * @param {object} payload
         * @param {string} nextStep
         */
        __updateUserAccount(payload, nextStep) {
            this.__clearErrors()
            this.buttonDisabled = true

            return this.$apollo
                .mutate({
                    mutation: ACCOUNT_UPDATE_MUTATION,
                    variables: {
                        ...payload,
                        signupStatus: nextStep,
                    },
                })
                .then((res) => {
                    const userErrors = Array.isArray(
                        res.data.accountUpdate?.userErrors
                    )
                        ? res.data.accountUpdate?.userErrors
                        : []

                    if (userErrors?.length === 0) {
                        // lets stay safe and remove the creditsafeId from the payload
                        if (payload?.creditsafeId) {
                            delete payload.creditsafeId
                        }

                        if (this.stepNameForTracking !== 'error') {
                            trackClick(
                                this.stepNameForTracking,
                                {
                                    category: 'Retailer Registration',
                                    payload,
                                },
                                ''
                            )
                        }

                        setTimeout(() => {
                            this.pageAnimateIn = false
                            this.emitNextStep(nextStep)
                        }, 200)
                    } else {
                        this.userErrors = userErrors
                        trackGQLErrors(this.userErrors, this.$data)
                    }
                })
                .catch((e) => {
                    console.warn(e)
                })
                .finally(() => {
                    this.buttonDisabled = false
                })
        },

        __clearErrors() {
            this.userErrors = []
        },
        emitNextStep(nextStep) {
            setTimeout(() => {
                this.$emit('success', nextStep)
            }, 201)
        },
    },
}
